import React from 'react';
import { money } from '../../utils/format';

/**
 * Un monto de plata.
 *
 * Existe para que todos los montos de la app compartan el mismo formato y la
 * misma tipografía sin que haya que acordarse en cada pantalla: la clase
 * `si-money` los pone en monoespaciada con cifras de ancho fijo, así las
 * columnas de una tabla quedan alineadas solas y los dígitos no bailan cuando
 * el valor cambia.
 *
 * `decimales` sólo para valores que de verdad los tienen (el valor del punto
 * en el reparto por puntos); las propinas son enteras.
 */
export default function Money({ value, decimales = false, className = '' }) {
  return (
    <span className={`si-money ${className}`.trim()}>
      {money(value, { decimales })}
    </span>
  );
}
